import { useCallback } from "react";
import { BankCashItemType } from "@common/types/bankCashItem";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useGlobalTransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/useGlobalTransactionViewDrawer";

interface AddedCashItem {
    type: BankCashItemType;
    transactionId: number;
    entityId?: number;
}

export function useAddedCashItemToast() {
    const { toast, dismiss } = useToaster();
    const openGlobalTransactionViewDrawer = useGlobalTransactionViewDrawer();

    return useCallback(
        ({ type, transactionId, entityId }: AddedCashItem) => {
            const isCheck = type === BankCashItemType.CHECK;
            const toastId = toast(
                <HStack justify="between" align="center" gap={12}>
                    <span>{isCheck ? "Check added" : "Deposit added"}</span>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                            dismiss(toastId);
                            openGlobalTransactionViewDrawer(
                                {
                                    transactionIds: [transactionId],
                                    ...(entityId !== undefined && {
                                        entityIds: [entityId],
                                    }),
                                },
                                {
                                    autoSelectFirst: true,
                                    initialSelectedTransactionId: transactionId,
                                },
                            );
                        }}
                    >
                        {isCheck ? "View check" : "View deposit"}
                    </Button>
                </HStack>,
            );
        },
        [toast, dismiss, openGlobalTransactionViewDrawer],
    );
}
